const getters = {
    Openid: state => state.user.Openid,
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js